import React from "react";
import { inject } from "mobx-react";
import ProvidersContainer from "./containers/ProvidersContainer";
import { PlansB2BLayout } from "ComponentsUI/PlanB2B";
import BusinessBannerContainer from "Containers/BusinessBannerContainer";
import ReviewsContainer from "./containers/Reviews";
import WithSeoText from "Layouts/WithSeoText";
import DeclinationContainerNew from "Containers/DeclinationContainerNew";
import { SeoBlockContainer } from "Containers/SeoBlock";
import { Container } from "reactstrap";
import { generateUrl } from "Services/withDefaultParams";
import configRouters from "Configs/routes";
import { Helmet } from "react-helmet-async";

const nowShowBusinessTariffsRegions = [77, 50, 78, 47];

@inject("ApplicationModel")
export default class Page extends React.Component {
	canonical() {
		const {
			ApplicationModel: { siteConfig },
			match,
		} = this.props;

		let location = generateUrl(configRouters.OrderOffice.route, {
			regionUrl: match.params.regionUrl,
		});

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	}
	render() {
		const {
			seoData,
			ApplicationModel: { text },
			route,
		} = this.props;
		let currentRegionId = this.props.ApplicationModel.currentRegion.id;
		let dontShowTariffs = !!nowShowBusinessTariffsRegions.find((item) => item === currentRegionId);

		return (
			<>
				{this.canonical()}
				<DeclinationContainerNew>
					<BusinessBannerContainer
						h1Banner={seoData && seoData.h1}
						h1Slider={text.SERVICE_FOR_BUSINESS}
					/>
				</DeclinationContainerNew>
				<WithSeoText seoData={seoData} text={text}>
					<ProvidersContainer />
					{!!dontShowTariffs && <PlansB2BLayout text={text} />}
					<Container>
						<SeoBlockContainer route={route} placeText="SeoBlock1" bgText={true} />
					</Container>
					<ReviewsContainer />
				</WithSeoText>
				<Container>
					<SeoBlockContainer route={route} placeText="SeoBlock2" bgText={true} />
					<SeoBlockContainer route={route} placeText="SeoBlock3" bgText={true} />
				</Container>
			</>
		);
	}
}
